

// 是否显示loading
export const IS_LOADING = "IS_LOADING";
export const SET_TABLE_SELECT = "SET_TABLE_SELECT";

export const SET_TABS_NAME_OBJ = "SET_TABS_NAME_OBJ";

export const SET_MENU_STATE = "SET_MENU_STATE";


export const SET_TABS = "SET_TABS";

export const SET_AUD_UUID = "SET_AUD_UUID";


export const SET_BTN = "SET_BTN";
// 设置表格头
export const SET_TABLE_COLUMNS = "SET_TABLE_COLUMNS";

export const SET_ROUTERS = "SET_ROUTERS";

export const SET_SUBJECT_TYPE  = "SET_SUBJECT_TYPE";

export const IS_ACTIVE_KEY = "IS_ACTIVE_KEY";
// 获取表格数据
export const GET_TABLE_DATA = "GET_TABLE_DATA";

export const SET_ROUTER_TAGS = "SET_ROUTER_TAGS";


export const SET_SIDEBAR_ROUTERS="SET_SIDEBAR_ROUTERS";

export const DELETE_ROUTE_TAGS = "DELETE_ROUTE_TAGS";





// WEBPACK FOOTER //
// ./src/store/types.js